import styled from 'styled-components';
import { FiEdit, FiPlus } from 'react-icons/fi';
import { MdDelete } from 'react-icons/md';

export const ManualImportContainer = styled.div`
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  background: #fff;

  h2{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 32px 32px 32px;
    align-self: stretch;
    color: var(--Gray-gray-800, #40444C);
    text-align: center;

    /* text-heading-l-bold */
    font-family: Nunito;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 36px */
    letter-spacing: -0.24px;
    // margin-bottom: 40px;
  }

  .tituloRendaFixa{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0px;
    align-self: stretch;
    color: var(--Gray-gray-800, #40444C);
    text-align: center;

    /* text-heading-l-bold */
    font-family: Nunito;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 36px */
    letter-spacing: -0.24px;
    // margin-bottom: 40px;
  }

  .btn-video {
    display: flex;
    height: 40px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
        
    color: var(--Primary-brand-500, #EC6643);
    background-color: transparent;
    text-align: center;

    /* text-base-semi */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 143%; /* 20.02px */
    letter-spacing: 0.14px;

    border-radius: 8px;
    border: 1px solid var(--Primary-brand-500, #EC6643);

    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  .btn-video:hover {
    background-color: var(--Primary-brand-500, #EC6643);
    color: white;
  }

  .btn-video:hover svg {
    color: white;
    fill: white;
  }
  

  h4{
    align-self: stretch;
    padding: 0px 32px 0 32px;
    color: var(--Gray-gray-600, #6A717E);

    /* text-heading-m-semi */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%; /* 32px */
    margin-bottom: 40px;
  }
  
  p{
    color: var(--Gray-gray-600, #6A717E);
    padding: 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /* text-paragraph-m */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }

  .p{
    color: var(--Gray-gray-600, #6A717E);
    padding: 0px 16px 0 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /* text-paragraph-m */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    
  }
  
  .infoPasso{
    display: flex;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
    padding: 0px 32px 0 32px;
    margin-bottom: -1.6rem;

    .steps-box{
      display: flex;
      width: 809px;
      padding: 24px 32px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      border-radius: 8px;
      background: #FFFCF5;

      h3{
        align-self: stretch;
        color: var(--Gray-gray-800, #40444C);

        /* text-paragraph-l-med */
        font-family: Poppins;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 156%; /* 28.08px */
      }
      
      textPasso{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
        li{
          display: flex;
          align-items: center;
          gap: 8px;
          align-self: stretch;
          color: var(--Gray-gray-600, #6A717E);

          /* text-paragraph-m-semi */
          font-family: Poppins;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 150%; /* 24px */
        }
      }

    }
    
    .video-box{
      display: flex;
      padding: 24px 32px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      flex: 1 0 0;
      align-self: stretch;

      border-radius: 8px;
      background: var(--Interface-interface-25, #F5F5F7);

      .tituloVideo{
        align-self: stretch;
        color: var(--Gray-gray-800, #40444C);

        /* text-paragraph-l-med */
        font-family: Poppins;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 156%; /* 28.08px */
      }

      .btn-video {
        display: flex;
        height: 40px;
        padding: 8px 24px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        
        color: var(--Primary-brand-500, #EC6643);
        background-color: transparent;
        text-align: center;

        /* text-base-semi */
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 143%; /* 20.02px */
        letter-spacing: 0.14px;

        border-radius: 8px;
        border: 1px solid var(--Primary-brand-500, #EC6643);

        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }

      .btn-video:hover {
        background-color: var(--Primary-brand-500, #EC6643);
        color: white;
      }

      .btn-video:hover svg {
        color: white;
        fill: white;
      }

    }
  }
  .contentButtons{
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    .comeceJa{
      color: var(--Gray-gray-800, #40444C);
      width: 100%;
      max-width: 851px;
      margin-top: 56px;

      /* text-paragraph-l-med */
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 156%; /* 28.08px */
      margin-bottom: 0rem;
    }
    .buttonArea{
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      gap: 16px;
      align-self: stretch;
      
      .containerbutton{
        display: flex;
        height: 393.937px;
        padding: 32px;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        flex: 1 0 0;
        .svg{
          width: 41.145px;
          height: 65.937px;
          flex-shrink: 0;
        }
        .text{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          flex: 1 0 0;
          align-self: stretch;
          .tituloButton{
            align-self: stretch;
            color: var(--Gray-gray-800, #40444C);

            /* text-paragraph-m-semi */
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 150%; /* 24px */
            margin-bottom: -0.2rem;
          }
          .paragrafoButton{
            align-self: stretch;
            color: var(--Gray-gray-800, #40444C);

            /* text-paragraph-m */
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 24px */
            margin-bottom: -0.6rem;
          }
        }
          
        .button { 
          display: flex;
          height: 40px;
          padding: 8px 24px;
          justify-content: center;
          align-items: center;
          gap: 8px;

          border-radius: 8px;
          border: 1px solid var(--Primary-brand-500, #EC6643);

          color: var(--Primary-brand-500, #EC6643);
          background-color: transparent;

          text-align: center;
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 143%; /* 20.02px */
          letter-spacing: 0.14px;

          cursor: pointer; /* opcional */
          transition: all 0.2s ease-in-out; /* deixa suave */
        }

        .button:hover {
          background-color: var(--Primary-brand-500, #EC6643);
          color: white;
        }
      }
    }
  }
  .modal-overlay {
    display: flex;
    padding: 40px;
    flex-direction: column;
    gap: 32px;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .modal-content {
    display: flex;
    width: 800px;
    height: auto;
    padding: 40px;
    flex-direction: column;
    gap: 32px;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -1rem;
    h3{
      flex: 1 0 0;
      color: var(--Gray-gray-800, #40444C);

      /* text-heading-m-semi */
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 160%; /* 32px */
    }
  }

  .modal-body {
    margin-top: 0;
    .text-modal{
      align-self: stretch;
      color: var(--Gray-gray-800, #40444C);

      /* text-paragraph-m */
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
    }
  }

  .actions {
    display: flex;
    gap: 12px;
    align-items: flex-end;
    justify-content: flex-end; /* joga tudo pra direita */
    .button { 
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;

      border-radius: 8px;
      border: 1px solid var(--Primary-brand-500, #EC6643);

      color: var(--Primary-brand-500, #EC6643);
      background-color: transparent;

      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;

      cursor: pointer; /* opcional */
    }
    .button2 { 
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;

      border-radius: 8px;
      border: 1px solid var(--Primary-brand-500, #EC6643);
      background-color: var(--Primary-brand-500, #EC6643);
      color: white;
      

      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;

      cursor: pointer; /* opcional */
    }
  }
  .objetivos-modal {
    padding: 20px;
  }

  .objetivos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
    margin-top: 10px;
  }

  .objetivo-card {
    border-radius: 8px;
    border: 1px solid var(--Gray-gray-200, #C0C3C9);
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    flex: 1 0 0;

    cursor: pointer;
    transition: 0.2s;
    
    .tituloObjetivo{
      height: 72px;
      align-self: stretch;
      color: var(--Gray-gray-800, #40444C);
      text-align: center;

      /* text-paragraph-m */
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
    }
  }

  .objetivo-card:hover {
    border-radius: 8px;
    border: 2px solid var(--Primary-brand-500, #EC6643);
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 15px 20px;
    border-top: 1px solid #eee;
    .button { 
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;

      border-radius: 8px;
      border: 1px solid var(--Primary-brand-500, #EC6643);

      color: var(--Primary-brand-500, #EC6643);
      background-color: transparent;

      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;

      cursor: pointer; /* opcional */
    }
    .button2 { 
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;

      border-radius: 8px;
      border: 1px solid var(--Primary-brand-500, #EC6643);
      background-color: var(--Primary-brand-500, #EC6643);
      color: white;
      

      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;

      cursor: pointer; /* opcional */
    }
  }

  .close {
    background: transparent;
    border: none;
    font-size: 40px;
    cursor: pointer;
  }

  .floating-video {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 360px;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    z-index: 9999;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  }

  .floating-video iframe {
    width: 100%;
    height: 100%;
  }

  .close-video {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    color: #fff;
    font-size: 14px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    cursor: pointer;
  }

`;

export const ContentTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 32px 32px 0 32px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-weight: 400;
      font-size: 1rem;
      color: #303F4B;
    }
    .buttonContent {
      display: flex;
      flex-direction: row;
      gap: 1.5rem;
      align-items: center;
      button {
        all: unset;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;

        cursor: pointer;
      }
      .addNewActiveButton {
        padding: 0.5rem 0.75rem;
        border-radius: 39px;
        background: ${(props) => props.theme['primary-800']};
        color: ${(props) => props.theme.white};
        font-weight: 400;
        font-size: 1rem;
      }

      .trashButton {
        background: ${(props) => props.theme['white-200']};
        border-radius: 100%;
        padding: 0.5rem;
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
`;

export const ContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  .containerTable{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    .tituloRendaFixa{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0px;
      align-self: stretch;
      color: var(--Gray-gray-800, #40444C);
      text-align: center;

      /* text-heading-l-bold */
      font-family: Nunito;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 36px */
      letter-spacing: -0.24px;
      // margin-bottom: 40px;
    }

    .buttonTable{
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background: #fff; 
      border: 1px solid var(--Primary-brand-500, #EC6643);
      color: var(--Primary-brand-500, #EC6643);
      text-align: center;

      /* text-base-semi */
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;
      transition: background 0.2s ease;
    }
    .buttonTable:hover {
      background-color: var(--Primary-brand-500, #EC6643);
      color: white;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 132px;
  width: 380px;
  padding: 24px 16px 0px 0px;
  border-radius: 8px;
  border: 1px solid var(--Gray-gray-200, #C0C3C9);
  background: #fff;

  .patrimonioTitulo {
    color: var(--Gray-gray-600, #6A717E);
    font-family: Poppins, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 143%;
    margin-bottom: 8px;
  }

  .cardPatrimonio {
    display: flex;
    padding: 0px 16px 32px 32px;
    justify-content: space-between;

    .numberInfo {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      h3 {
        color: var(--Gray-gray-800, #40444C);
        font-family: Poppins, sans-serif;
        font-size: 20px;
        font-weight: 600;
        line-height: 160%;
        margin: 0;
      }

      .data {
        color: var(--Gray-gray-500, #8C919D);
        font-size: 12px;
        line-height: 1.4;
      }
    }
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;

  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    div {
      display: flex;
      align-items: center;
      gap: 8px;

      .box-objetivos {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-gray-800, #40444C);
        text-align: center;

        /* text-heading-m-semi */
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 160%; /* 32px */
      }

      .svg {
        width: 32px;
        height: 32px;
        aspect-ratio: 1/1;
      }
    }

    .buttonBox {
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background: #fff; 
      border: 1px solid var(--Primary-brand-500, #EC6643);
      color: var(--Primary-brand-500, #EC6643);
      text-align: center;

      /* text-base-semi */
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 143%; /* 20.02px */
      letter-spacing: 0.14px;
      transition: background 0.2s ease;

      &:hover {
        background-color: var(--Primary-brand-500, #EC6643);
        color: white;
      }
    }
  }

  .aviso {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #FFF6E6;
    padding: 12px 16px;
    border-radius: 8px;
    border-left: 4px solid #F5A623;

    &::before {
      content: '⚠️';
      font-size: 16px;
      line-height: 1;
      flex-shrink: 0;
      margin-top: 2px;
    }

    strong {
      color: var(--Chart-Gold-gold-900, #6B4600);
      font-family: Poppins;
      font-size: 16px;
      font-weight: 600;
      line-height: 150%;
      margin-right: 4px; /* dá um pequeno espaçamento entre o strong e o p */
      white-space: nowrap; /* evita quebra de linha no 'Atenção' */
    }

    p {
      color: var(--Chart-Gold-gold-800, #8C5B00);
      font-family: Poppins;
      font-size: 14px;
      font-weight: 400;
      line-height: 143%;
      letter-spacing: 0.14px;
      word-break: normal;
      overflow-wrap: break-word;
      margin: 0; /* remove margens padrão do <p> */
    }
  }
  
  .boxes-container{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(283px, 1fr));
    gap: 32px;
    width: 100%;


    .box-item{
      display: flex;
      width: 283px;
      height: 379px;
      padding: 24px;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      border-radius: 8px;
      border: 1px solid var(--Gray-gray-200, #C0C3C9);
      // cursor: pointer;

      .icon-area {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 16px;
        
        .icons-box{
           display: flex;
           flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;

          .icon {
            display: flex;
            align-items: center;
          }

          .icon2 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            
          }
        }
        
        .box-header{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          
          align-self: stretch;

          .title-box{
            color: var(--Gray-gray-800, #40444C);

            /* text-paragraph-l-med */
            font-family: Poppins;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 156%; /* 28.08px */
          }

          .descricao{
            align-self: stretch;
            color: var(--Gray-gray-600, #6A717E);

            /* text-base */
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 143%; /* 20.02px */
          }
        }     
      }

      .progress-bar-container {
        width: 100%;
        height: 6px;
        background-color: #F9D0C5;
        border-radius: 50px;
        margin: 12px 0;
        z-index: 2;
      }

      .info{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;
      

        .info-box{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
          align-self: stretch;
          
          .info-numbers{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 2px;
            align-self: stretch;

            .info-valor{
              color: var(--Gray-gray-400, #9196A1);

              font-family: Poppins;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 133%; /* 18.62px */
              letter-spacing: 0.14px;
            }
            
            .info-aplicado{
              color: var(--Gray-gray-800, #40444C);

              /* text-paragraph-m-semi */
              font-family: Poppins;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 150%; /* 24px */
            }
            
          }
          
          .info-meta{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 4px;
            align-self: stretch;

            .de{
              color: var(--Gray-gray-400, #9196A1);
              font-family: Poppins;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 133%; /* 18.62px */
              letter-spacing: 0.14px;
            }

            .info-valor-meta{
              color: var(--Gray-gray-800, #40444C);
              text-align: right;

              /* text-paragraph-m-semi */
              font-family: Poppins;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 150%; /* 24px */
            }
          }

        
          .progress-bar-fill {
            width: 100%;
            height: 8px;

            border-radius: 4px 0 0 4px;
            background: var(--Primary-brand-500, #EC6643);
            position: relative;
            transition: width 0.3s ease;
          }

          .progress-handle {
            position: absolute;
            right: -8px; // bolinha fica na ponta
            top: 50%;
            transform: translateY(-50%);
            width: 16px;
            height: 16px;
            background-color: #f26a1b;
            border-radius: 50%;
            border: none;
            box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info-meta{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 4px;
            align-self: stretch;
          }
        }
        .renda-fixa{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          align-self: stretch;

          .ticker-item{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            align-self: stretch;
          
            .ticker-name{
              color: var(--Gray-gray-600, #6A717E);
              font-family: Poppins;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 133%; /* 15.96px */
              letter-spacing: 0.12px;
            }
          }
        }
      }
    }

    .box-item criar-novo{
      display: flex;
      width: 283px;
      height: 379px;
      padding: 24px;
      flex-direction: column;
      align-items: flex-start;
      gap: 32px;
      cursor: pointer;

      border-radius: 8px;
      border: 1px solid var(--Gray-gray-200, #C0C3C9);

      .textBox{
        align-self: stretch;
        color: var(--Gray-gray-600, #6A717E);
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 133%; /* 15.96px */
        letter-spacing: 0.12px;

      }
    }
  }

`;


export const DeleteActive = styled(MdDelete)`
  font-size: 15px;
  cursor: pointer;
`;
export const EditActive = styled(FiEdit)`
  font-size: 15px;
  cursor: pointer;
`;
export const AddActive = styled(FiPlus)`
  font-size: 15px;
  cursor: pointer;
  color: ${(props) => props.theme.black};
`;

export const HeaderStyle = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.white};
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: ${(props) => props.theme['card-shadow-2']};

  .contentFilter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-left: 1rem;
  }
  div {
    display: flex;
    gap: 1rem;
    align-items: center;

    .divider {
      height: 30px;
      width: 1px;
      background: rgba(21, 21, 21, 0.3);
    }
    input {
      border: ${(props) => props.theme.border};
      border-radius: 4px;
      padding: 0.2rem 0.5rem;
    }

    p {
      font-size: 1rem;
      margin: 0;
      cursor: pointer;
      transition: color 0.3s;
      :hover {
        color: ${(props) => props.theme.primary};
      }
    }

    .activeFilter {
      color: ${(props) => props.theme.primary};
      font-weight: 700;
      border-bottom: 1px solid ${(props) => props.theme.primary};
    }

    button {
      border: none;
      outline: none;
      background-color: transparent;
      font-size: 1rem;
      transition: color 0.3s;

      :hover {
        color: ${(props) => props.theme.primary};
      }
    }
    button.delete {
      color: #ff6363;
    }
    button.delete:hover {
      color: red;
    }
  }

  @media (max-width: 577px) {
    flex-direction: column;
    align-items: start;

    .contentFilter {
      margin-left: 0;
      margin-top: 10px;
    }

    div {
      width: 100%;
      input {
        width: 100%;
      }

      button {
        display: flex;
        justify-content: flex-end;
        width: 120px;
      }
    }
  }
`;

export const DeleteAllActives = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .buttonContent {
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }
`;

const backgroundColorForType = {
  acao: '#FFB900',
  FII: '#006AAC',
  rendaFixa: '#FF8B4B',
};

interface IPropsTypeActiveContent {
  typeActive: 'acao' | 'FII' | 'rendaFixa';
}

export const TypeActiveContent = styled.span<IPropsTypeActiveContent>`
  padding: 0.25rem 0.5rem;
  border-radius: 41px;
  color: ${(props) => props.theme.white};
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  white-space: nowrap;
  background: ${(props) => backgroundColorForType[props.typeActive]};
`;

export const CompanyNameContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  strong {
    font-size: 0.875rem;
    font-weight: 500;
    color: ${(props) => props.theme['gray-400']};
    max-width: 15ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span {
    font-weight: 400;
    font-size: 0.625rem;
    color: ${(props) => props.theme['gray-400']};
    max-width: 25ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;